export interface BlogPostSummary {
  featureImage?: string
  featureImageAlt: string
  featureImageWebp?: string
  slug: string
  title: string
}

// Only the navigation's featured post needs metadata in the global client bundle.
const frontmatterModules = import.meta.glob(
  "../routes/_content/blog/-content/2026-10-26-the-git-forge-for-agent-human-collaboration.mdx",
  {
    eager: true,
    import: "frontmatter",
  },
) as Record<string, Record<string, unknown>>

function slugFromPath(path: string) {
  const filename = path
    .split("/")
    .pop()!
    .replace(/\.(mdx?|md)$/, "")

  return filename.replace(/^\d{4}-\d{2}-\d{2}-/, "")
}

function optionalString(value: unknown) {
  return typeof value === "string" ? value : undefined
}

export const blogPostSummaries: BlogPostSummary[] = Object.entries(frontmatterModules)
  .sort(([a], [b]) => b.localeCompare(a))
  .map(([path, frontmatter]) => ({
    featureImage: optionalString(frontmatter["featureImage"]),
    featureImageAlt: optionalString(frontmatter["featureImageAlt"]) ?? "",
    featureImageWebp: optionalString(frontmatter["featureImageWebp"]),
    slug: slugFromPath(path),
    title: optionalString(frontmatter["title"]) ?? "",
  }))

export function getBlogPostSummary(slug: string) {
  return blogPostSummaries.find((post) => post.slug === slug)
}
